import { useState } from "react";
import { Plus } from "lucide-react";

export const TRIGGERS = [
  { v: "alcohol", label: "Alcohol" },
  { v: "caffeine-late", label: "Caffeine after noon" },
  { v: "sugar", label: "Sugar" },
  { v: "spicy", label: "Spicy food" },
  { v: "late-night", label: "Late night" },
  { v: "skipped-meal", label: "Skipped a meal" },
  { v: "stress", label: "Big stress" },
  { v: "screens-late", label: "Screens late" },
];

const slug = (s) => s.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function TriggerPicker({ value, onChange }) {
  const [other, setOther] = useState("");
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  const custom = value.filter((v) => !TRIGGERS.some((t) => t.v === v));

  const addOther = () => {
    const v = slug(other);
    if (!v) return;
    if (!value.includes(v)) onChange([...value, v]);
    setOther("");
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {TRIGGERS.map((t) => (
          <button
            key={t.v}
            type="button"
            className="chip"
            data-active={value.includes(t.v)}
            onClick={() => toggle(t.v)}
            data-testid={`checkin-trigger-${t.v}`}
          >
            {t.label}
          </button>
        ))}
        {custom.map((v) => (
          <button
            key={v}
            type="button"
            className="chip"
            data-active="true"
            onClick={() => toggle(v)}
            data-testid={`checkin-trigger-custom-${v}`}
          >
            {v.replace(/-/g, " ")}
          </button>
        ))}
      </div>
      <div className="mt-4 flex items-center gap-2 max-w-sm">
        <input
          className="input-paper"
          placeholder="Something else in the mix?"
          value={other}
          onChange={(e) => setOther(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addOther(); } }}
          data-testid="checkin-trigger-other-input"
        />
        <button
          type="button"
          onClick={addOther}
          className="w-11 h-11 shrink-0 rounded-full border border-[#D8CBB9] bg-[#FFFDF9] hover:bg-[#F4EDE2] flex items-center justify-center"
          aria-label="Add"
          data-testid="checkin-trigger-other-add"
        >
          <Plus size={16} />
        </button>
      </div>
    </div>
  );
}
